"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationUtils = void 0;
/** NotificationUtils class. */
var NotificationUtils = /** @class */ (function () {
    function NotificationUtils() {
    }
    // This function is set/unset by the singleton instance of the main component
    NotificationUtils.notify = function () { };
    return NotificationUtils;
}());
exports.NotificationUtils = NotificationUtils;
//# sourceMappingURL=notification.js.map